import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'

// Components
import BollardAxisBerths from './bollardAxisBerths/BollardAxisBerths'
import BollardAxisLabels from './bollardAxisLabels/BollardAxisLabels'
import BollardLoadStations from './bollardLoadStations/BollardLoadStations'
import { QUAY_ROLES } from '../../../js/constants'
import './BollardAxis.scss'

export default class BollardAxis extends PureComponent {
  static propTypes = {
    bollardToScreen: PropTypes.func.isRequired,
    config: PropTypes.object.isRequired,
    showExternal: PropTypes.bool.isRequired
  }

  render() {
    const normalQuays = this.props.config.quays.filter(
      quay => quay.role === (this.props.showExternal === true ? QUAY_ROLES.external : QUAY_ROLES.normal)
    )
    return (
      <div className="bollard-axis">
        {!this.props.showExternal && (
          <BollardAxisLabels quays={normalQuays} bollardToScreen={this.props.bollardToScreen} />
        )}

        <BollardAxisBerths
          berths={[].concat(...normalQuays.filter(quay => quay.berths).map(quay => quay.berths))}
          bollardToScreen={this.props.bollardToScreen}
        />

        {!this.props.showExternal && (
          <BollardLoadStations bollardToScreen={this.props.bollardToScreen} quays={normalQuays} />
        )}
      </div>
    )
  }
}
